export const games = [
  {
    id: 'touhou1',
    name: 'Touhou 1: Highly Responsive to Prayers',
    shortName: 'Touhou 1',
    appKey: 'Touhou 1',
    icon: '/custom/games/Icon_th01.png',
    type: 'iframe',
    url:
      'https://web.archive.org/web/20210510113837if_/https://www.windows93.net/d/programs/dosbox/?soft=Touhou',
  },
  {
    id: 'touhou2',
    name: 'Touhou 2: Story of Eastern Wonderland',
    shortName: 'Touhou 2',
    appKey: 'Touhou 2',
    icon: '/custom/games/Icon_th02.png',
    type: 'iframe',
    url:
      'https://web.archive.org/web/20211213130520if_/https://www.windows93.net/d/programs/dosbox/?soft=Touhou_2',
  },
  {
    id: 'touhou3',
    name: 'Touhou 3: Phantasmagoria of Dim.Dream',
    shortName: 'Touhou 3',
    appKey: 'Touhou 3',
    icon: '/custom/games/Icon_th03.png',
    type: 'iframe',
    url:
      'https://web.archive.org/web/20211213130938if_/https://www.windows93.net/d/programs/dosbox/?soft=Touhou_3',
  },
  {
    id: 'touhou4',
    name: 'Touhou 4: Lotus Land Story',
    shortName: 'Touhou 4',
    appKey: 'Touhou 4',
    icon: '/custom/games/Icon_th04.png',
    type: 'iframe',
    url:
      'https://web.archive.org/web/20241006133624if_/http://www.windows93.net/d/programs/dosbox/?soft=Touhou_4',
  },
  {
    id: 'touhou5',
    name: 'Touhou 5: Mystic Square',
    shortName: 'Touhou 5',
    appKey: 'Touhou 5',
    icon: '/custom/games/Icon_th05.png',
    type: 'iframe',
    url:
      'https://web.archive.org/web/20210211084838if_/http://www.windows93.net/d/programs/dosbox/?soft=Touhou_5',
  },
  {
    id: 'quake3',
    name: 'Quake III Arena',
    shortName: 'Quake 3',
    appKey: 'Quake 3',
    icon: '/custom/games/quake-3-icon.png',
    type: 'iframe',
    url: '/custom/games/quake-3/Quake3.htm',
    loadingMode: 'message',
    defaultSize: {
      width: 1040,
      height: 760,
    },
  },
  {
    id: 'ultrakill',
    name: 'ULTRAKILL',
    shortName: 'ULTRAKILL',
    appKey: 'ULTRAKILL',
    icon: '/custom/games/ultrakill-icon.png',
    type: 'iframe',
    url: '/custom/games/ultrakill/index.html',
    loadingMode: 'message',
    defaultSize: {
      width: 1040,
      height: 760,
    },
  },
  {
    id: 'catmario',
    name: 'Syobon Action',
    shortName: 'Syobon Action',
    appKey: 'Syobon Action',
    icon: '/custom/games/cat-mario-icon.png',
    type: 'iframe',
    url: '/custom/games/cat-mario/index.html',
    loadingMode: 'message',
    defaultSize: {
      width: 480,
      height: 420,
    },
  },
  {
    id: 'supermonkeyballjr',
    name: 'Super Monkey Ball Jr.',
    shortName: 'Super Monkey Ball Jr.',
    appKey: 'Super Monkey Ball Jr.',
    icon: '/custom/games/super-monkey-ball-jr-icon.png',
    type: 'iframe',
    url: '/custom/games/super-monkey-ball-jr/index.html',
    loadingMode: 'message',
    defaultSize: {
      width: 900,
      height: 600,
    },
  },
  {
    id: 'portal2d',
    name: 'Portal 2D',
    shortName: 'Portal 2D',
    appKey: 'Portal 2D',
    icon: '/custom/games/portal-2d-icon.png',
    type: 'iframe',
    url: '/custom/games/portal-2d/index.html',
    defaultSize: {
      width: 980,
      height: 730,
    },
  },
  {
    id: 'vampiresurvivors',
    name: 'Vampire Survivors',
    shortName: 'Vampire Survivors',
    appKey: 'Vampire Survivors',
    icon: '/custom/games/vampire-survivors-icon.png',
    type: 'iframe',
    url: '/custom/games/vampire-survivors/index.html',
    defaultSize: {
      width: 1032,
      height: 686,
    },
  },
];
